const Sitehost = () => {
  return (
    <div>
      <h1>Sitehost Integration</h1>
    </div>
  )
}

export default Sitehost